import axios from "axios"

export default {
  getAdAccountPixels(adAccountId) {
    const url = `/fam/adaccounts/${adAccountId}/pixels`

    return axios.get(url).then(response => {
      return response.data
    })
  },
}
